/**
 * アプリケーション情報
 */
export default {
  state: {
    // 地図の初期値（エラー時などに利用）
    mapDefaultLocation: { lat: 34.693240, lng: 135.526040 },
    // 地図のデフォルトの倍率
    mapDefaultZoom: 14,
    // 店舗をリロードする半径（緯度経度）
    shopReloadLocation: 0.005,

    // 言語情報
    language: ''
  },
  getters: {
    /**
     * 地図の言語
     */
    apps_mapLanguage (state) {
      switch (state.language) {
        case 'ja':
          return 'ja'

        case 'cn':
          return 'zh-CN'

        default:
          return 'en'
      }
    },
    /**
     * 地図の地域
     */
    apps_mapRegion (state) {
      switch (state.language) {
        case 'ja':
          return 'JP'

        case 'cn':
          return 'cn'

        default:
          return 'en'
      }
    }
  },
  actions: {
  },
  mutations: {
    /**
     * 言語情報
     */
    apps_language (state, value) {
      state.language = value
    }
  }
}
